import createDataReducer from "../../helpers/createDataReducer";
import deltas from "../../actions/deltas";

const {
    SET_LAST_UPDATED_AT,
} = deltas.actionTypes;

export default createDataReducer(
    SET_LAST_UPDATED_AT,
);
